import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/buyer-discounts-list',
            name: 'admin-buyer-discounts-list',
            component: () => import(/* webpackChunkName: "page-admin-buyer-management-discounts-buyer-discounts-list" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "分销商优惠列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "分销商优惠管理"
                                        },
                                        {
                                                  name: "分销商优惠列表"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
